<template>
  <div class="wrapper">
    <div class="header">
      <div class="main">
        <p>全溯应用市场</p>
        <div class="search">
          <van-search 
            v-model="value"
            left-icon
            shape="round"
            :placeholder="placeholder"
            :clearable="false"
            @search="search"
          >
            <template #right-icon>
              <div class="button" @click="search">搜索</div>
            </template>
          </van-search>
          <!-- <img src="@/assets/images/down.png" class="msg" @click="enterMsg"> -->
        </div>
      </div>
    </div>
    <div class="fill"></div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: '搜索关键词/APP/应用'
    },
    showMsg: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      value: '',
      countNum:0
    }
  },
  created(){
    
  },
  methods: {
    search() {
      this.$emit('search', this.value.trim())
    },
    enterMsg() {
      this.$router.push('/msg-center')
    },

  }
}
</script>

<style lang="less" scoped>
.wrapper {
  .header {
    width: 100%;
    height: 100px;
    background: url(../../assets/imgs/top-bj.png) no-repeat center/100% 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
    box-sizing: border-box;
    padding: 5px 13px 12px 13px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    .main {
      p {
        font-size: 17px;
        font-weight: bold;
        color: #fff;
        text-align: center;
        margin-bottom: 15px;
      }
      .search {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .area {
          display: flex;
          align-items: center;
          img {
            width: 13px;
            height: 17px;
            margin-right: 8px;
          }
          span {
            color: #fff;
          }
        }
        .msg {
          width: 17px;;
          height: 17px;
        }
        .hideMsg {
          visibility: hidden;
        }
      }
    }
  }
  .fill {
    height: 97px;
  }
}
.button {
  width: 45px;
  height: 24px;
  border-radius: 12px;
  text-align: center;
  line-height: 24px;
  font-size: 12px;
  color: #fff;
  background: var(--blue);
  transform: scale(1.15);
}
.van-search {
  padding: 0;
  border-radius: 17px;
  width: 100%;
}
</style>